import type { CatalogoDescriptor } from '@next/compartilhados/catalogos'

export type TipoPerfilDePermissao = 'mine' | 'group' | 'all'

export const ehTipoPerfilDePermissao = (valor: unknown): valor is TipoPerfilDePermissao => valor === 'mine' || valor === 'group' || valor === 'all'

export type OpcaoPerfilDePermissao = Readonly<{
  id: string
  name: string
  description?: string | null
  kind?: TipoPerfilDePermissao | null
}>

export type FiltrosCatalogoPerfilDePermissao = Readonly<{
  id?: readonly string[]
  kind?: readonly TipoPerfilDePermissao[]
}>

export type SelecaoCatalogoPerfilDePermissao = OpcaoPerfilDePermissao | readonly OpcaoPerfilDePermissao[] | null
export type OperacoesCatalogoPerfilDePermissao = Readonly<{ listarOpcoes: (sinal: AbortSignal) => Promise<readonly OpcaoPerfilDePermissao[]> }>

const CAMPOS_PROJECAO = new Set(['id', 'name', 'description', 'kind'])

export const DESCRITOR_CATALOGO_PERFIL_DE_PERMISSAO: CatalogoDescriptor<OpcaoPerfilDePermissao> = Object.freeze({
  nome: 'perfis-de-permissao',
  versaoProjecao: 2,
  validarItens: (valor: unknown): valor is readonly OpcaoPerfilDePermissao[] => (
    Array.isArray(valor) && valor.every((item: unknown) => typeof item === 'object' && item !== null && !Array.isArray(item)
      && Object.keys(item).every(campo => CAMPOS_PROJECAO.has(campo)))
  ),
})
